import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy, ChangeDetectorRef, Output, EventEmitter, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import _ from 'lodash';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { FieldSourceType, IDropdownFilter, IReportFilterControl } from 'src/app/models';
import { PortalService, ReportService } from 'src/app/services';
import { MatSelectSearchComponent } from '../../mat-select-search/mat-select-search.component';
import { Constants } from 'src/app/shared/models/constants';

@Component({
    selector: 'medpt-report-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropdownComponent implements OnInit, OnDestroy {

  @Input() field!: IReportFilterControl;
  @Input() allControls!: Array<IReportFilterControl>;
  @Input() isMedPoint!: boolean;
  @Input() preSelectAll!: boolean;
  @Input() reportName!: string;
  @Input() form!: FormGroup;
  @Input() SafetyReportData!: any[];
  @Output() filterChangeData = new EventEmitter<any>();  

  @ViewChild(MatSelectSearchComponent) resetValue !:  MatSelectSearchComponent;

  @ViewChild(TooltipDirective, { static: true }) public tooltipDir: TooltipDirective | undefined;
  @ViewChild('search') SearchTextBox!: ElementRef;
  dropdownSearchTextboxControl = new FormControl();
  /** list of value filtered by search keyword for multi-selection */
  public filteredDataSource: any = []; // ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  /** Subject that emits when the component has been destroyed. */
  private _onDestroy = new Subject<void>();

  placeholderText = "";
  constructor(
    private portalService: PortalService,
    private reportService: ReportService,
    private cd: ChangeDetectorRef
  ) {
    //this.filteredDataSource.next([]);
    this.filteredDataSource = [];
  }

  ngOnInit(): void {


  }

  ngOnChanges(changes: SimpleChanges) {    
    let portalInfo = this.portalService.portalConfiguation.getValue();
    let sponsor = <string>portalInfo.SponsorName;
    let portalId = <number>portalInfo.PortalID;
    
    if (this.field.dataSource == null || this.SafetyReportData != undefined) {

      let promiseData: Promise<any> = new Promise(() => { });
      if (this.SafetyReportData != undefined && this.SafetyReportData != null) {
        let data: any[];
        promiseData = new Promise((resolve, reject) => {
          var valueField = (this.field.fieldSourceType == FieldSourceType.SusarTitle) ? "SusarTitle" : (this.field.fieldSourceType == FieldSourceType.Compound) ? "Compound" : (this.field.fieldSourceType == FieldSourceType.Country_of_Origin) ? "Country_of_Origin" :
            (this.field.fieldSourceType == FieldSourceType.Study_of_Origin) ? "Study_of_Origin" :  (this.field.fieldSourceType == FieldSourceType.Type_Abbreviation)? "TypeAbbreviation" :
              (this.field.fieldSourceType == FieldSourceType.Death_or_Life_Threatening)? "Death_or_Life_Threatening" : (this.field.fieldSourceType == FieldSourceType.Protocol_of_Origin) ? "Protocol_of_Origin" :"";
          if (valueField != "")
            data = _.map(_.uniq(_.map(this.SafetyReportData, (item) => { return item[valueField]; })), (item) => { return { Text: item, Value: item }; }).sort((a, b) => (a.Text < b.Text ? -1 : 1));
          else if (this.field.fieldSourceType == FieldSourceType.AE_Term) {
            let customisedAE_Term: any[] = [];
            for (var i = 0; i < this.SafetyReportData.length; i++) {
              if (this.SafetyReportData[i].AE_Term.length > 0) {
                for (var j = 0; j < this.SafetyReportData[i].AE_Term.length; j++) {
                  customisedAE_Term.push(this.SafetyReportData[i].AE_Term[j]);
                }
              }
            }
            data = _.map(_.uniq(_.map(customisedAE_Term)), (item) => { return { Text: item, Value: item }; }).sort((a, b) => {
              return a.Text.localeCompare(b.Text, undefined, {
                numeric: true,
                sensitivity: 'base'
              })
            });
          }
          else if (this.field.fieldSourceType == FieldSourceType.Global_Case_ID)
            data = _.map(_.uniq(_.map(this.SafetyReportData, (item) => { return item.Global_Case_ID; })), (item) => { return { Text: item, Value: item }; }).sort((a, b) => (a.Text < b.Text ? -1 : 1));
          else if (this.field.fieldSourceType == FieldSourceType.Visit_Type)
            data = _.map(_.uniq(_.map(this.SafetyReportData, (item) => { return item.Visit_Type; })), (item) => { return { Text: item, Value: item }; }).sort((a, b) => (a.Text < b.Text ? -1 : 1));
             else if(this.field.fieldSourceType == FieldSourceType.Initial_Follow_up) {
              data = [{ Text: "Initial", Value: "Intl" }, { Text: "Follow-up", Value: "FU" }];
              resolve(data);
            }
          resolve(data);
        });
        //  promiseData = titles;
      }
      else {        
        if (this.field.fieldSourceType == FieldSourceType.AssetCategory || this.field.fieldSourceType == FieldSourceType.StudyStatAssetCategory || this.field.fieldSourceType == FieldSourceType.StudyStatAssetSubCategory) {
          promiseData = this.reportService.getFilterData('Categories', sponsor, portalId, <string>this.field.dropdownGroupType);
        }
        else if (this.field.fieldSourceType == FieldSourceType.Country) {
          promiseData = this.reportService.getFilterData('Countries', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.Title) {
          promiseData = this.reportService.getFilterData('Assets', sponsor, portalId, <string>this.field.dropdownGroupType);
        }

        else if (this.field.fieldSourceType == FieldSourceType.SafetyReportTitle) {
          promiseData = this.reportService.getFilterData('SafetyReports', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.DocumentStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Active", Value: "Active" }, { Text: "Retired", Value: "Retired" }];
            resolve(data);
          });
        }

        else if (this.field.fieldSourceType == FieldSourceType.TrainingActiveStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Active", Value: "Active" }, { Text: "Retired", Value: "Retired" }];
            resolve(data);
          });
        }

        else if (this.field.fieldSourceType == FieldSourceType.FAQCategory) {
          promiseData = this.reportService.getFilterData('FaqCategories', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.FAQSection) {
          promiseData = this.reportService.getFilterData('FaqSections', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.Forum) {
          promiseData = this.reportService.getFilterData('Forums', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.MessageCategory) {
          promiseData = this.reportService.getFilterData('MessageCategories', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.Poll) {
          promiseData = this.reportService.getFilterData('Polls', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.PortalLevel) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Enterprise Level", Value: "Enterprise Level" }, { Text: "Program Level", Value: "Program Level" }, { Text: "Study Level", Value: "Study Level" }];
            resolve(data);
          });
        }

        else if (this.field.fieldSourceType == FieldSourceType.PrimaryCRA) {
          promiseData = this.reportService.getFilterData('AllCRAUsers', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.SafetyReportStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Not Signed", Value: "Not Signed" }, { Text: "Signed", Value: "Signed" }, { Text: "Waived", Value: "Waived" }, { Text: "Acknowledged By Site", Value: "Acknowledged By Site" }];
            resolve(data);
          });
        }

        else if (this.field.fieldSourceType == FieldSourceType.SiteName) {
          promiseData = (this.isMedPoint) ? this.reportService.getFilterData('AllSites', sponsor, portalId) : this.reportService.getFilterData('Sites', sponsor, portalId);
        }
        else if (this.field.fieldSourceType == FieldSourceType.DeclinedSiteName) {
          promiseData = this.reportService.getFilterData('DeclinedSites', sponsor, portalId);
        }
        else if (this.field.fieldSourceType == FieldSourceType.SiteRole) {
          promiseData = this.reportService.getFilterData('Roles', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.Topic) {
          promiseData = this.reportService.getFilterData('Topics', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.User) {
          promiseData = (this.isMedPoint) ? this.reportService.getFilterData('AllUsers', sponsor, portalId) : this.reportService.getFilterData('Users', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.SponsorEnterpriseUsers) {
          promiseData = this.reportService.getFilterData('SponsorEnterpriseUsers', sponsor, portalId);
        }

        else if (this.field.fieldSourceType == FieldSourceType.UserStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Active", Value: "Active" }, { Text: "Inactive", Value: "Inactive" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.MetricsUserStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Deactivated", Value: "Deactivated" }, { Text: "Registered", Value: "Registered" }, { Text: "Unregistered", Value: "Unregistered" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.DelegationAction) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Delegate", Value: "1" }, { Text: "Assign Training", Value: "2" }, { Text: "Change Required/Optional", Value: "3" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.AssignmentStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Active", Value: "1" }, { Text: "Inactive", Value: "0" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.TrainingAssignmentStatus) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Active", Value: "1" }, { Text: "Retired", Value: "2" }, { Text: "Unassigned", Value: "0" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.SignatureRequirement) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "eSign Required", Value: "eSigRequired" }, { Text: "No eSign Required", Value: "NOeSig" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.ViewRequirement) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "View Required", Value: "ViewRequired" }, { Text: "View Optional", Value: "ViewOptional" }];
            resolve(data);
          });
        }
        else if (this.field.fieldSourceType == FieldSourceType.SafetyReportType) {
          promiseData = this.reportService.getFilterData('SafetyReportTypes', sponsor, portalId);
        }
        else if (this.field.fieldSourceType == FieldSourceType.SafetyReportEnabledStudy) {
          promiseData = this.reportService.getFilterDataBySponsor('SafetyReportsEnabledStudyList', sponsor);
        }
        else if (this.field.fieldSourceType == FieldSourceType.Portal) {
          promiseData = this.reportService.getFilterDataBySponsor('Portal', sponsor);
        }
        else if (this.field.fieldSourceType == FieldSourceType.SiteType) {
          promiseData = new Promise((resolve, reject) => {

            let data = [{ Text: "MedPoint", Value: "1" }, { Text: "Sponsor", Value: "2" }, { Text: "Study Site", Value: "3" }, { Text: "CRO", Value: "4" }];
            if (!this.isMedPoint) {
              data = _.filter(data, (x) => { return x.Text != Constants.SITETYPE_MEDPOINTSITETYPE_NAME });
            }
            resolve(data);
          });

        } else if (this.field.fieldSourceType == FieldSourceType.TrainingSource) {
          promiseData = new Promise((resolve, reject) => {

            let data = [{ Text: "MedPoint", Value: "1" }, { Text: "Sponsor", Value: "2" }];
            resolve(data);
          });
        } else if (this.field.fieldSourceType == FieldSourceType.OverrideAssignmentTypes) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "Assign Training", Value: "2" }, { Text: "Change Status", Value: "3" }];
            resolve(data);
          });
        } else if (this.field.fieldSourceType == FieldSourceType.StatisfactoryResponse) {
          promiseData = new Promise((resolve, reject) => {
            let data = [{ Text: "No Response", Value: "1" }, { Text: "Satisfactory", Value: "2" }, { Text: "No Satisfactory", Value: "3" }];
            resolve(data);
          });
        }else if(this.field.fieldSourceType == FieldSourceType.AIQuestionCategoryName) {
          promiseData = this.reportService.getFilterDataBySponsor('AIQuestionCategories', sponsor);
          
        }
      }
      promiseData.then((result: any[]) => {
        if(this.field.fieldSourceType == FieldSourceType.StudyStatAssetCategory){
           var studyStatCategories = _.filter(result, (r)=> {return (r.PortalID == portalId && r.ParentCategoryID == 0)});
           result = studyStatCategories;
        }
        if(this.field.fieldSourceType == FieldSourceType.StudyStatAssetSubCategory){
            var studyStatCategories = _.filter(result, (r)=> {return (r.PortalID == portalId && r.ParentCategoryID > 0)});
            result = studyStatCategories;
        }
        if (this.field.fieldSourceType == FieldSourceType.SiteName && (this.reportName === 'SafetyReportsCompletionSummaryReport' || this.reportName === 'SafetyReportsCompletionDetailReport')) {
          var studySites = _.filter(result, (x) => { return x.SiteTypeID === Constants.SITETYPE_STUDYSITE_ID });
          result = studySites;
        }
        this.field.unFormatedDataSource = result;

        this.field.dataSource = _.map(result, (item: any) => {
          const text = this.field.fieldSourceType == FieldSourceType.SiteName ? item['SiteNumber'] + " - " + item[<string>this.field.textField] : item[<string>this.field.textField];
          const value = this.field.textAsValueField ? item[<string>this.field.textField] : item[<string>this.field.valueField];
          let objItem = {
            Text: text,
            Value: value,
            Visibled: true
          };
          return objItem;
        });
        this.filteredDataSource = this.field.dataSource.slice();
        const pickableFieldSourceTypes = new Set([FieldSourceType.SafetyReportEnabledStudy, FieldSourceType.Portal]);
        let placeholderTextPart = pickableFieldSourceTypes.has(this.field.fieldSourceType!) ? 'Select a ' : '';
        this.placeholderText = (this.field.dataSource.length > 0 ? placeholderTextPart : "No ") + this.field.placeholderText;

        if (this.preSelectAll) {
          this.selectAll(true);
        }

      }, () => { }).catch(() => { }).finally(() => { });
    }
    else {
      if (this.field.unFormatedDataSource != undefined) {
        if (this.field.unFormatedDataSource.length == 0)
          this.field.unFormatedDataSource = this.field.dataSource;
      }
      this.filteredDataSource = this.field.dataSource.slice();
      let placeholderTextPart = this.field.fieldSourceType == FieldSourceType.SafetyReportEnabledStudy ? 'Select a ' : '';
      this.placeholderText = (this.field.dataSource.length > 0 ? placeholderTextPart : "No ") + this.field.placeholderText;

      if (this.preSelectAll) {
        this.selectAll(true);
      }
    }
    this.cd.detectChanges();
    /** Set filter event based on value changes */
    this.dropdownSearchTextboxControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => this.filterDropDown());
  }
  private filterDropDown() {
    if (!this.field.dataSource) {
      return;
    }
    // get the search keyword
    let search = this.dropdownSearchTextboxControl.value;
    if (!search) {
      this.filteredDataSource = this.field.dataSource.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDataSource = this.field.dataSource.filter(item => item.Text.toLowerCase().indexOf(search) > -1)
  }

  openedChange(e: any) {
    // Set search textbox value as empty while opening selectbox 
    try {
      this.dropdownSearchTextboxControl.patchValue('');
    } catch (e) {
      console.log(e);
    }
  }

  selectAll(all: boolean) {
    this.form.controls[this.field.controlName].markAsDirty();
    let value: any = [];
    if (this.dropdownSearchTextboxControl.value != undefined && this.dropdownSearchTextboxControl.value != null && this.dropdownSearchTextboxControl.value != '') {
      this.filteredDataSource?.forEach((item: any) => {
        value.push(item.Value);
      });
    }
    else {
      this.field.dataSource?.forEach((item: any) => {
        value.push(item.Value);
      });
    }
    if (!all) {
      this.form.controls[this.field.controlName].setValue([]);
      this.resetValue.previousSelectedValues = [];
    } else {
      this.form.controls[this.field.controlName].setValue(value);
    }
    this.onFilterChange({ value: value });
    this.onFilterChange({ value: value });
  }

  //filter for SafetyReport Grid
  onFilterChange(e: any) {



    if ((this.SafetyReportData != undefined && this.SafetyReportData != null) || ((this.field.fieldSourceType == FieldSourceType.SafetyReportType && (this.reportName != 'SafetyReportsCompletionSummaryReport' && this.reportName != 'EnterpriseSafetyReportsCompletionSummaryReport' && this.reportName != 'SafetyReportsDistributionReport' && this.reportName != 'EnterpriseSafetyReportsDistributionReport') ) || (this.field.fieldSourceType == FieldSourceType.SafetyReportType && (this.reportName == 'SafetyReportsManagementReport' || this.reportName == 'SafetyReportsCompletionDetailReport' || this.reportName == 'EnterpriseSafetyReportsCompletionDetailReport')) || this.field.fieldSourceType == FieldSourceType.SafetyReportEnabledStudy || this.reportName== 'DocumentViewsReport'  || this.field.fieldSourceType == FieldSourceType.Portal)) {

      this.filterChangeData.emit(e);
    }
  }

  getToolTipData(matSelect: MatSelect) {
    var selectedValue = _.map(_.filter(this.field.dataSource, (v) => _.includes(matSelect.value, v.Value)), (item) => { return item.Text });
    return selectedValue.join(" * ");
  }
  
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
